import React from 'react';
import './AgreementBox.less';

interface AgreementBoxPropsType {
    prefixCls?: string;
    onAgree?: () => void;
}

class AgreementBox extends React.Component<AgreementBoxPropsType, any> {
    static defaultProps = {
        prefixCls: 'agreement-box'
    };

    render() {
        const {prefixCls, onAgree} = this.props;
        return (
            <div className={`${prefixCls}`}>
                <div className={`${prefixCls}-wrapper`}>
                    <p className={`${prefixCls}-title`}>国孕商城用户服务协议</p>
                    <div className={`${prefixCls}-content`}>
                        特别提示：<br />
                        欢迎来到国孕商城！<br />
                        为使用国孕商城服务，您应当阅读并遵守《国孕商城用户服务协议》（以下简称“本协议”）。请您在进一步操作之前仔细阅读、充分理解本协议的各个条款，特别是以加粗形式提示您注意的条款。您有权选择同意或不同意本协议，您点击“我已阅读并同意”按钮即视为您已阅读并接受本协议的所有条款。<br />
                        您完成注册国孕合伙人平台账号登录国孕商城平台，使用国孕商城平台服务，即视为您已充分阅读、理解本协议，并自愿受本协议的约束。阅读本协议过程中，如您不同意本协议或其中任何条款，请立即停止注册程序并停止使用国孕商城平台服务。<br />
                        本“特别提示”是本协议正文的组成部分。<br />
                        <b>1.定义</b><br />
                        1.1国孕商城：是指国孕商城平台的经营者，即深圳天橙一品科技有限公司。作为电子商务平台经营者，国孕商城仅为用户提供优质的商品，并提供赚取佣金的服务，真正满足消费者和代理商的需求，实现多方共赢。您完全理解并同意，国孕商城基于平台管理和保护消费者利益的需要，依据国孕商城与供应商之间的约定或协议，督促供应商履行其对于商品及服务的承诺或赔付责任，但这并不意味着国孕商城须承担与此相关的任何法律责任（包括但不限于连带责任、担保责任、补充责任等）。<br />
                        1.2国孕商城平台：是指深圳天橙一品科技有限公司经营的电商平台，包括但不限于国孕商城微信端商城、国孕合伙人国孕商城功能板块。<br />
                        1.3国孕商城用户服务协议：即本协议，指您与国孕商城订立的旨在约定您登陆、使用国孕商城平台，以及通过国孕商城平台下达订单、购买商品、支付货款、收取商品、分享商品等过程中，您与国孕商城之间的权利、义务的书面合同。<br />
                        1.4国孕商城规则：包括所有国孕商城已经发布或将来可能发布、修订的各类规则、规范、规则解读、实施细则、通知、公告等。<br />
                        <b>2.协议范围及变更</b><br />
                        2.1本协议内容正文及国孕商城规则，均具有同等法律效力。<br />
                        2.2为给您提供更好的服务，国孕商城将根据业务变化，相应调整本协议。国孕商城将对修订内容提前进行公示，修订后的协议一经实施，讲完全代替修订前的协议。您应当及时关注和了解本协议的修订情况、公告、提示信息等，如果您不同意修订后协议，请您立即停止使用国孕商城平台，否则即视为您同意并完全接受修订后的协议。<br />
                        2.3如您在首次使用国孕商城平台时，未及时阅读本协议，您的使用行为视为对本协议的同意，本协议效力将塑及至您首次使用国孕商城平台之日。<br />
                        <b>3.用户注册</b><br />
                        3.1在注册国孕商城用户账户之前，您应当确认并承诺，您具备中华人民共和国法律规定的与您行为相适应的民事行为能力。<br />
                        3.2您可以通过注册国孕合伙人用户账户登录并使用国孕商城平台。<br />
                        3.3注册国孕合伙人用户账户时，必须提供准确真实的个人资料，如个人资料有任何变动，应在资料发生变动后及时提交联系客服更新。因用户未及时联系更新产生的责任，由用户自行承担。<br />
                        3.4您的账户由您自行设置并保管，国孕商城任何时候均不会主动要求您提供您的账户密码。因您保管账号、密码不当造成的所有后果，将由您自行承担。凡经您的账号和密码成功登录使用国孕商城平台即视为您的使用行为；您应当对您的账户进行所有活动及后果负法律责任。您不得以任何形式擅自转让或授权他人使用您的账户，因您主动泄露、出借账户信息或因您遭受他人攻击、诈骗等行为导致的损失及后果，国孕商城并不承担责任，您可以通过司法、行政等救济途径向侵权行为人追偿。<br />
                        <b>4.商品购买及代理商收益行为</b><br />
                        4.1当您在国孕商城平台购买商品时，请您务必仔细确认所购商品的名称、价格、数量、型号、规格、尺寸等重要事项，并在下单时核实您的联系地址、电话、收货人等信息。如您填写的收货人非您本人，则该收货人的行为和意思表示产生的法律后果均由您承担。<br />
                        4.2商品的购买行为及代理商的转发分享行为应当基于真实的消费需求或合法的赚佣方式，不得实施恶意购买、恶意维权、恶意竞争、非法传播等扰乱国孕商城平台正常秩序的行为。基于维护国孕商城平台交易秩序及交易安全的需求，国孕商城发现上述情形时有权采取关闭相关购买及商品分享流程，限制账户使用功能、中止或终止服务等措施而无需事先通知您。<br />
                        4.3除另有明确说明外，国孕商城平台上销售的商品的相关信息由国孕商城制作、上传，国孕商城尽可能提供准确、完整、可靠、有效、没有错误和误导性的商品描述。然而，您充分理解，国孕商城平台上存在海量信息，因为互联网技术及人力的局限性，国孕商城不能保证平台上所有商品的信息均准确、完整、可靠、有效、没有错误和没有误导性。除国孕商城有明显过错外，对于商品信息导致的纠纷，国孕商城不承担任何责任。<br />
                        4.4由于国孕商城平台目前处于运营初期，对于代理商的分享、转发、推荐商品及获取佣金过程中可能存在一定技术漏洞；代理商理解由于网络软件、硬件、技术等出现的临时性平台功能缺陷，并不得利用临时性功能缺陷进行非法、获取非法利益；同时，国孕商城将尽可能的保护好代理商通过合法正当途径获取的佣金收益。<br />
                        4.5如果您使用国孕商城平台时存在违反国家法律法规、本协议、侵害他人利益、国孕商城利益或社会公共利益、严重违背社会公德等情形，国孕商城有权采取删除相关信息、中止或终止提供服务等处理措施。<br />
                        4.6您理解并同意，因您违反本协议或国孕商城规则而产生的第三方索赔请求，由您自行承担法律责任；由此导致国孕商城遭受损失的，您也应当一并赔偿。<br />
                        <b>5.用户守则</b><br />
                        5.1遵守中国现行有关的法律和法规； 遵守所有与网络服务有关的网络协议、规定和程序。<br />
                        5.2不得为了任何非法目的而使用国孕商城网络服务系统；<br />
                        5.3不得利用国孕商城网络服务系统进行任何可能对互联网的正常运转造成不利影响的行为；<br />
                        5.4不得利用国孕商城网络服务系统传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；<br />
                        5.5不得利用国孕商城网络服务系统进行任何不利于本服务的行为；<br />
                        5.6国孕商城提供的是本平台运营者自选商品的购物服务，消费者免费使用国孕商城以得到物美价廉的商品，并且可以通过成为国孕商城代理商创业赚钱；<br />
                        5.7如发现任何非法使用用户帐号或帐号出现安全漏洞的情况，应立即告知国孕商城工作人员，如有故意利用国孕商城系统漏洞去获取个人利益者，平台方将有权冻结个人账号的同时移交相关法律机关；<br />
                        5.8在宣传介绍本平台及本服务时，禁止夸大、诱导、虚假宣传：如月入百万、轻松暴富、用色情图片或色情文字诱导、虚假头条新闻或其他虚假描述等不真实宣传； 一切解释权归国孕商城运营方所有。<br />
                        5.9用户在使用国孕商城网络服务过程中，必须遵循以上规定，如有违反，造成的一切法律责任，由用户承担。<br />
                        <b>6.有限责任</b><br />
                        6.1不论任何情况下，国孕商城均不对由于Internet连接故障，电脑、通讯或其他系统的故障，电力故障，计算机病毒，程序漏洞，罢工，劳动争议，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪灾，风暴，爆炸，不可抗力，战争，政府行为，国际、国内法院的命令或第三方的不作为而造成的不能服务或延迟服务承担责任。<br />
                        6.2除法律法规规定外，国孕商城有权单方面地中止或者终止国孕商城平台所提供的服务而无须提前通知您。您理解并同意，国孕商城需要定期或者不定期地对国孕商城平台、设备进行维护或者检修，因此造成的国孕商城服务在合理时间内的中断，国孕商城无需为此承担任何责任，但国孕商城将尽可能事先通知您。<br />
                        <b>7.期限、解除和终止</b><br />
                        7.1本协议自您确认同意之日起生效并长期有效。<br />
                        7.2出现以下情况时，国孕商城可以本协议约定的方式通知您终止本协议：<br />
                        1）您违反本协议约定，国孕商城依据违约条款终止本协议的；<br />
                        2）您盗用他人账户、发布违禁信息、骗取他人财物、扰乱市场秩序、采取不正当手段谋利等行为，国孕商城依据国孕商城规则对您的账户予以查封的；<br />
                        3）除上述情形外，因您多次违反国孕商城规则相关规定且情节严重，国孕商城依据国孕商城规则对您的账户予以查封的；<br />
                        4）您的账户被国孕商城依据本协议回收的；<br />
                        5）其他应当终止服务的情况。<br />
                        7.3协议终止或解除后后续事项的处理：<br />
                        1）自本协议终止或解除之日起，国孕商城将关闭您在国孕商城平台的账户权限。<br />
                        2）本协议终止或解除后，国孕商城有权保留您的注册信息及使用行为记录等数据，但国孕商城没有为您保留这些数据的义务，亦不承担在协议终止后向您或第三方提供任何数据信息的义务，也不就协议终止向您或任何第三方承担责任，但法律法规另有规定的除外。<br />
                        3）本协议终止或解除后，国孕商城仍保留对您过往的违约行为追究责任的权利。<br />
                    </div>
                    <div className={`${prefixCls}-btn`} onClick={onAgree}>我同意</div>
                </div>
            </div>
        );
    }
}

export default AgreementBox;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/giftComp/agreementBox/AgreementBox.tsx